import React from "react";
import { AppRouter } from "./app/routes/router";

export default function App() {
  return <AppRouter />;
}
